import { useState, useMemo, useRef, useEffect } from 'react';
import { FormContext } from '../context/form-context';
import omit from 'lodash/omit';

export const Form = ({ onSubmit, className = '', children, touched: touchedProp, onTouchedChange, ...props }) => {
	const inputStatesRef = useRef({})
	const [inputStates, setInputStates] = useState(inputStatesRef.current);
	const inputValuesRef = useRef({})
	const [inputValues, setInputValues] = useState(inputValuesRef.current);
	const [touched, setTouchedRaw] = useState(touchedProp ?? false);
	const [submissionCount, setSubmissionCount] = useState(0);

	const setTouched = (newVal) => {
		onTouchedChange?.(newVal);
		setTouchedRaw(newVal);
	}

	const onTouch = () => {
		setTouched(true);
	}

	const [validationErrors, initialized] = useMemo(() => {
		var initialized = Object.keys(inputStates).length > 0;
		var validationErrors = [];

		for(const inputKey of Object.keys(inputStates)) {
			if(!inputStates[inputKey].initialized) {
				initialized = false;
			}
			if(!!inputStates[inputKey].validationError) {
				validationErrors.push(inputStates[inputKey].validationError);
			}
		}

		return [validationErrors, initialized]
	}, [inputStates])

	const updateInputState = (name, initialized, validationError) => {
		inputStatesRef.current = {
			...inputStatesRef.current,
			[name]: {
				initialized,
				validationError,
			}
		};
		setInputStates(inputStatesRef.current)
	}

	const updateInputValue = (name, id, value) => {
		let newValue = name.endsWith('[]') ? {
			...inputValuesRef.current[name] ?? {},
			[id]: value,
		} : value;

		inputValuesRef.current = {
			...inputValuesRef.current,
			[name]: newValue,
		};
		setInputValues(inputValuesRef.current)
	}

	const removeInput = (name) => {
		inputStatesRef.current = omit(inputStatesRef.current, name);
		setInputStates(inputStatesRef.current);
	}

	const submitForm = (e) => {
		e.preventDefault();
		setSubmissionCount(count => count + 1);

		if(validationErrors.length > 0) {
			setTouched(true);
		}
		else {
			if(onSubmit) {
				onSubmit(Object.keys(inputValues).reduce((filteredValues, key) => {
					if(inputValues[key] !== undefined) {
						return {
							...filteredValues,
							[key]: typeof inputValues[key] === 'string' ? inputValues[key] : Object.keys(inputValues[key]).map(id => inputValues[key][id]).filter(v => v !== undefined),
						}
					}
					else {
						return filteredValues;
					}
				}, {}));
			}
			else {
				console.warn('Unhandled form submission:', inputValues);
			}
		}
	}

	useEffect(() => {
		setTouchedRaw(touchedProp);
	}, [touchedProp])

	return (
		<FormContext.Provider value={{
			touched,
			onTouch,
			initialized,
			updateInputState,
			updateInputValue,
			removeInput,
			validationErrors,
			submissionCount,
		}}>
			<form
				{...props}
				noValidate
				className={`inputform ${className}`}
				onSubmit={submitForm}>
				{children}
			</form>
		</FormContext.Provider>
	)
}